import { DebtGroupsPage } from './DebtGroupsPage';

export function PayablesListPage() {
  return <DebtGroupsPage side="payables" />;
}
